import React, {useState, useEffect, useReducer} from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage, useDebounce } from 'react-use';
import AnswerAction from './AnswerAction';
import useNotif from 'hooks/use-notify-hook';
import {
  Button,
  Card,
  Col,
  Form,
  Container,
  Row,
} from 'react-bootstrap';
import FileUpload from 'components/FileUpload/FileUpload.js';
import PlanContext from './Utils/context.js';
import PlanReducer from './Utils/reducer.js';
import { ACTIONS } from './Utils/action.js';
import AnswerRepository from 'repository/Answer.js';

function Input({ answer, scores, auditeeTeams = [], scheduleId, actionTypes = []}) {

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  // const [score, setScore] = useState(scores.find(item => item.INDEX_ID === answer.INDEX_ID)?.INDEX_ID ?? `n/a`)
  const [score, setScore] = useState(scores.find(item => item.INDEX_ID === answer.INDEX_ID)?.INDEX_ID ?? `n/a`);
  const [cause, setCause] = useState(answer?.CAUSE_DESC ?? ``);
  const [editEv, setEditEv] = useState(false);
  const [evaluate, setEvaluate] = useState(answer?.EVALUATE_DESC ?? null);
  const [attachments, setAttachments] = useState(answer?.answerAttachments ?? []);
  const [actions, dispatchActions] = useReducer(PlanReducer, answer?.answerActions ?? []);
  const repository = new AnswerRepository(auth.token);

  let filePromises = [];

  const handleEdit = async () => {
    setEditEv(true);
  }

  const handleUpload = async (file) => {

    try {
      filePromises.push(repository.upload(answer.ANSWER_ID, file));
      const promises = await Promise.all(filePromises);
      // setAttachments([...attachments, ...promises.map(item => item.data)]);
      promises.map(item => attachments.push(item.data));
      dispatchNotif({
        place: `br`,
        message: `Upload Success...`,
        type: `success`,
      });

      filePromises = [];

    } catch(ex) {

      dispatchNotif({
        place: `br`,
        message: `Upload Failed ${ex.toString()}`,
        type: `danger`,
      });

    }
  }

  const handleChangeScore = async ({target: {value}}) => {

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}answers/${answer.ANSWER_ID}`,
        {INDEX_ID: value},
        {headers: {Authorization: `Bearer ${auth.token}`}},
      );

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

      setScore(value);

    } catch (error) {

      console.log(error);
      alert(error);
    }
  }

  const [, cancelCause] = useDebounce(async () => {

    const data = {
      CAUSE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
      CAUSE_BY: auth.employee.EMP_ID,
      CAUSE_DESC: cause,
    };

    const response = await repository.answer(answer.ANSWER_ID, data);

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [cause]);

  const [, cancelEvaluation] = useDebounce(async () => {

    const data = {
      EVALUATE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
      EVALUATE_BY: auth.employee.EMP_ID,
      EVALUATE_DESC: evaluate,
    };

    const response = await repository.answer(answer.ANSWER_ID, data);

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [evaluate]);


  const handleAddAction = async () => {

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}answer-actions`, {
          ACTION_TYPE_ID: 1,
          ANSWER_ID: answer.ANSWER_ID,
        },
        { headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      dispatchActions({
        type: ACTIONS.CREATE,
        payload: {
          ANSWER_ACTION_ID: response.data.ANSWER_ACTION_ID,
          ACTION_TYPE_ID: response.data.ACTION_TYPE_ID,
          ANSWER_ID: response.data.ANSWER_ID,
        }
      });

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  }

  useEffect(() => {
    cancelCause();
  }, []);

  useEffect(() => {
    cancelEvaluation();
  }, []);

  return (
    <PlanContext.Provider value={{
      scheduleId,
      answer,
      auditeeTeams,
      actionTypes,
      actions, dispatchActions
    }}>
      <Row>
        {notif}
        <Col md="12">
          <Card>
            <Card.Header>
            <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
              <div style={{whiteSpace: 'pre-wrap', marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
              <hr></hr>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md="8">
                  <Form.Group>
                    <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Auditee's Answer</Form.Label>
                    <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.ANSWER_DESC ?? 'N/A'}} />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Auditor's Evaluation</Form.Label>
                    <div></div>
                    {!editEv ?
                      <Button onClick={() => {setEditEv(true)}} variant="primary" size='sm'>Edit</Button>
                    :''}
                    {editEv ?
                      <div>
                        <Form.Control
                          value={evaluate}
                          onChange={({ target: { value }}) => setEvaluate(value)}
                          as="textarea"
                          rows={3}
                          isInvalid={evaluate?.length > 4000}
                        />
                        <Form.Text id="passwordHelpBlock" muted>
                          Total characters: {evaluate?.length ?? 0} / 4000
                        </Form.Text>
                      </div>
                    :<p><div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: evaluate ?? 'N/A'}} /></p>
                    }
                  </Form.Group>
                  <Form.Group>
                    <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Root Cause</Form.Label>
                    <Form.Control
                      value={cause}
                      onChange={({ target: { value }}) => setCause(value)}
                      as="textarea"
                      rows={3}
                      isInvalid={cause?.length > 4000}
                    />
                    <Form.Text id="passwordHelpBlock" muted>
                      Total characters: {cause?.length ?? 0} / 4000
                    </Form.Text>
                  </Form.Group>
                  <Form.Group>
                      <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Action Plan's</Form.Label>
                      {actions && actions.length > 0
                        ? actions.map((item, key) => <AnswerAction key={key} action={item} />)
                        : <p>No action plan defined.</p>
                      }
                  </Form.Group>
                  <Form.Group>
                    <Button onClick={handleAddAction} variant="primary">Add New Action</Button>
                  </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group>
                    <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Score</Form.Label>
                    <Form.Control
                      as="select"
                      value={score}
                      onChange={handleChangeScore}
                    >
                      <option value={'n/a'}>Please select</option>
                      {scores && scores.map((score, key) => (
                        <option key={key} value={score.INDEX_ID}>{score.SCORE_INDEX}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Attachment(s)</Form.Label>
                    {attachments && attachments.length > 0
                      ? (
                        <span className="form-control"
                          style={{
                            maxHeight: `200px`,
                            height: `200px`,
                            overflowY: `scroll`,
                            marginBottom: `10px`
                          }}
                        >
                          {attachments.map((attachment, key) => (
                            <div key={key} className="font-icon-detail">
                              <i className="nc-icon nc-attach-87"></i>{' '}
                              <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`} target="_blank" rel="noopener noreferrer">
                                {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                              </a>
                            </div>
                          ))}
                        </span>
                      )
                      : <p>No attachment uploaded.</p>
                    }
                    <FileUpload
                      onFileSelectSuccess={(file) => handleUpload(file)}
                      onFileSelectError={({ error }) => alert(error)}
                    >
                      Upload
                    </FileUpload>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </PlanContext.Provider>
  );
}

export default Input;